export const LocalStorageKeys = {
   UserData: 'Auth.user',
   DeviceId: 'Debug.deviceId',
   RemoteConsoleEnabled: 'Debug.remoteConsoleEnabled'
} as const
